import { render, staticRenderFns } from "./IconRobot.vue?vue&type=template&id=78cc2b2c&"
import script from "./IconRobot.vue?vue&type=script&lang=ts&"
export * from "./IconRobot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports